import {
    Form,
    Input,
    Button,
    Select,
    Result,
} from "antd";
import { useState } from "react";
import { useForm } from "antd/lib/form/Form";
import {
    signularisApi,
    useCreateMetaDocumentMutation,
    useGetRecipientsListQuery
} from "../../../store/api/signularisApi";
import { useSelector } from "react-redux";
import genDocument11 from '../misc/gendoc11';
import { RootState } from "../../../store/store";
import { useAppDispatch } from "../../../hooks/redux";
import { CREATE_DOCUMENT_ROUTE, MAIN_PAGE_ROUTE } from "../../../routing/consts";
import { Link } from "react-router-dom";
import { DocTemplateType } from "../../../types/types";
import { documentTemplates } from "../../../const";
import style from '../CreateDocument.module.scss';
import { SendOutlined } from "@ant-design/icons";

const { Item } = Form;
const { TextArea } = Input;
const { Option } = Select;

// Генерирует ID
let guid = () => {
    let s4 = () => Math.floor((1 + Math.random()) * 0x100).toString(10).substring(1);
    return s4() + s4() + s4() + s4();
}

// Форматирование даты
function styledDate() {
    const months = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля",
        "августа", "сентября", "октября", "ноября", "декабря"]
    const dobj = new Date()
    return `${dobj.getDate()} ${months[dobj.getMonth()]} ${dobj.getFullYear()}`
}

function Template() {
    const info = useSelector((state: RootState) => state.userinfo)
    const dispatch = useAppDispatch()
    const { data: recipients } = useGetRecipientsListQuery()
    const [form] = useForm()

    const defaulRepicients = ["62567bcc72944c7123ebde5a", '62303f756315cc23e79ca2c9']
    const recipientsList = recipients?.filter(item => !defaulRepicients.includes(item.id)) || []

    const [docname, setDocname] = useState("")
    const docTemplate: DocTemplateType = 'forInternalRelocation'

    const [createMetaDocument, {
        isLoading: mutationLoading,
        isSuccess: mutationSuccess,
    }] = useCreateMetaDocumentMutation()

    const onFinish = async (values: any) => {
        const regnum = guid()
        const templateName = documentTemplates.forInternalRelocation;
        setDocname(templateName)

        const formData = new FormData()
        formData.append("title", `${templateName} №${regnum}`)
        formData.append("brief", "Сгенерировано из шаблона")
        formData.append("recipients", (values.recipients || []).join(",") + ',' + defaulRepicients.join(","))
        formData.append("documentType", docTemplate)
        
        const templateValues = {
            ...values,
            regnum,
            regdate: styledDate(),
            dutyface: `${info.lastname} ${info.firstname} ${info.middlename}`,
            docTitle: 'Проректору по АХЧ \nЧегарбиеву А.С.' // Хардкод из оригинала
        }

        const pdfBytes = await genDocument11(templateValues, info)
        formData.append("file", new Blob([pdfBytes]))
        
        createMetaDocument(formData)
        dispatch(signularisApi.util.invalidateTags(['MetaDocument']))
    }

    if (mutationSuccess) return (
        <Result
            status="success"
            title="Заявка создана"
            subTitle={`Ваш документ успешно сформирован и отправлен на согласование.`}
            extra={<Link to={MAIN_PAGE_ROUTE + '/' + CREATE_DOCUMENT_ROUTE}><Button type="primary">Создать еще</Button></Link>}
        />
    );

    return (
        <div className={style.generatorWrapper}>
            <h2 className={style.title}>{documentTemplates.forInternalRelocation}</h2>
            
            <Form 
                form={form} 
                onFinish={onFinish} 
                layout="vertical"
                initialValues={{regtext: "Прошу дать разрешение на внутреннее перемещение "}}
            >
                <Item label="Дополнительные получатели" name="recipients">
                    <Select
                        mode="multiple"
                        placeholder="Выберите сотрудников..."
                        size="large"
                        allowClear
           filterOption={(input, option) =>
              (option?.label as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
                    >
                        {recipientsList?.map((recipient) => (
                                <Option key={recipient.id} value={recipient.id} label={recipient.fullname}>
                                {recipient.fullname} {!!recipient.position && <>- <span style={{color: 'gray', fontSize: 12}}>{recipient.position}</span></>}
                                </Option>
                            ))}
                    </Select>
                </Item>

                <div className={style.recipientTags}>
                    <span className={style.tag}>Магомедов Тимур Эейсаевич</span>
                    <span className={style.tag}>Чегарбиев Адлан Сулейманович</span>
                </div>

                <Item 
                    label="Текст заявки" 
                    name="regtext" 
                    rules={[{required: true, message: 'Обязательное поле'}]}
                >
                    <TextArea rows={5} placeholder="Укажите объекты и цель перемещения..."/>
                </Item>

                <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={mutationLoading}
                    size="large"
                    icon={<SendOutlined style={{ display: 'inline-flex' }} />}
                    style={{ 
                        width: '100%', 
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'center', 
                        justifyContent: 'center' 
                    }}
                >
                    Сформировать и отправить
                </Button>
            </Form>
        </div>
    )
}

export default Template;
